<template>
  <div>
    <el-dialog
      title="房产明细"
      :visible.sync="dialogVisible"
      width="90vw"
      :before-close="handleClose"
      class="house-urge-lock-history-dialog"
    >
      <div>
        <div class="header-tip" v-if="pageData&&pageData.statistics">
          催费房产数：{{pageData.statistics.count}}&nbsp;&nbsp;&nbsp;&nbsp;
          欠费金额：{{formatMoney(pageData.statistics.debt_amount,2)}}&nbsp;&nbsp;&nbsp;&nbsp;
          诉讼金额：{{formatMoney(pageData.statistics.lawsuit_amount,2)}}&nbsp;&nbsp;&nbsp;&nbsp;
          已催次数：{{pageData.statistics.record_count}}&nbsp;&nbsp;&nbsp;&nbsp;
          已催户数：{{pageData.statistics.record_house_count}}&nbsp;&nbsp;&nbsp;&nbsp;
          回款户数：{{pageData.statistics.return_count}}&nbsp;&nbsp;&nbsp;&nbsp;
          回款金额：{{formatMoney(pageData.statistics.return_money,2)}}&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
      </div>
      <div>
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          border
          style="width: 100%" height="60vh">
          <!--        <el-table-column type="selection" width="45" fixed></el-table-column>-->
          <el-table-column
            prop="房产信息"
            label="房产信息" width="320" fixed></el-table-column>
          <el-table-column
            prop="区域"
            label="区域"
            width="90">
          </el-table-column>
          <el-table-column
            prop="业主"
            label="业主姓名"
            width="100">
          </el-table-column>
          <el-table-column
            prop="业主电话"
            label="业主电话"
            width="150">
          </el-table-column>

          <el-table-column
            prop="是否催费"
            label="是否催费"
            width="100">
          </el-table-column>
          <el-table-column
            prop="催缴次数"
            label="催缴次数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="是否回款"
            label="是否回款"
            width="100">
            <template slot-scope="scope">
              <span style="color: #3ca92f" v-if="scope.row['是否回款']==='是'">{{scope.row['是否回款']}}</span>
              <span v-if="scope.row['是否回款']!=='否'"></span>
            </template>
          </el-table-column>

          <!--          <el-table-column-->
          <!--            label="银行划扣"-->
          <!--            width="90">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span style="color: #328628" v-if="scope.row.bankType">是</span>-->
          <!--              <span v-if="!scope.row.bankType"></span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="欠费起始月份"
            label="欠费起始月份"
            width="120">
          </el-table-column>
          <el-table-column
            prop="欠费月数"
            label="欠费月数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="欠费金额/诉讼金额"
            label="欠费金额/诉讼金额"
            width="140">
            <template slot-scope="scope">
              <el-link v-if="scope.row['催缴类型']!=='诉讼'" type="primary" size="mini" @click="getHouseBill(scope.row)">{{ formatMoney(scope.row['欠费金额'],2) }}</el-link>
              <span v-if="scope.row['催缴类型']==='诉讼'">{{formatMoney(scope.row['诉讼金额'],2)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="计划催缴月份"
            label="计划催缴月份"
            width="100">
          </el-table-column>
          <el-table-column
            prop="催缴类型"
            label="催缴类型"
            width="90">
          </el-table-column>
          <el-table-column
            prop="账龄类型"
            label="账龄类型"
            width="90">
          </el-table-column>
          <el-table-column
            prop="第三方合作单位"
            label="第三方合作单位"
            width="150">
          </el-table-column>
          <el-table-column
            prop="缴费类型"
            label="缴费类型"
            width="90">
          </el-table-column>

          <!--          <el-table-column-->
          <!--            prop="上次缴费时间"-->
          <!--            label="上次缴费时间"-->
          <!--            width="170">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-link type="primary" size="mini" @click="getLastHouseBill(scope.row)">{{ scope.row['上次缴费时间'] }}</el-link>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="上次缴费时间"
            label="上次缴费时间"
            width="170"></el-table-column>
          <el-table-column
            prop="第一次催费时间"
            label="第一次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="第二次催费时间"
            label="第二次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="第三次催费时间"
            label="第三次催费时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="催费次数"
            label="催费次数"
            width="90">
          </el-table-column>
          <el-table-column
            prop="欠费类型"
            label="欠费类型"
            width="150">
          </el-table-column>
          <el-table-column
            prop="欠费原因"
            label="欠费原因"
            width="150">
          </el-table-column>
          <el-table-column
            prop="业主诉求"
            label="业主诉求"
            width="150">
          </el-table-column>
          <el-table-column
            prop="解决措施"
            label="催费措施"
            width="150">
          </el-table-column>
<!--          <el-table-column-->
<!--            label="审批流程"-->
<!--            width="200">-->
<!--            <template slot-scope="scope">-->
<!--              <el-link v-if="scope.row.one_task_id" type="primary" size="mini" @click="openFlow(scope.row.one_task_id)">审批流程1</el-link>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            prop="user_name"
            label="操作人"
            width="100">
          </el-table-column>
<!--          <el-table-column-->
<!--            label="操作"-->
<!--            width="120" fixed="right">-->
<!--            <template slot-scope="scope">-->
<!--              -->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </el-dialog>
    <ViewFlow ref="viewFlowRef" />
  </div>
</template>

<script>
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";

export default {
  name: "HouseUrgeLockHistoryDialog",
  components: {ViewFlow},
  data() {
    return {
      url: "",
      where2:{
        project_ids:'',
        project_id:0,
        area_ids:'',
        area_id:0,
        year_month:0,
        urge_type:'',
        urge_types:"",
        debt_age_type:''
      },
      dialogVisible: false,
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.pageData = {
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      };
      this.url = "";
      this.where2={
        project_ids:'',
        project_id:0,
        year_month:0,
        urge_type:'',
        urge_types:"",
        debt_age_type:'',
        area_ids:'',
        area_id:0,
      }
    },
    show({url,project_ids,project_id,area_ids,area_id,year_month,urge_type,urge_types,debt_age_type}) {
      this.dialogVisible = true;
      this.where2.project_ids=project_ids;
      this.where2.project_id=project_id;
      this.where2.year_month=year_month;
      this.where2.urge_type=urge_type;
      this.where2.urge_types=urge_types;
      this.where2.debt_age_type=debt_age_type;
      this.where2.area_ids=area_ids;
      this.where2.area_id=area_id;
      this.url = url;
      this.pageChange(1);
    },
    getList(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where2)

      ButlerHttp.post(that.url,{
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      });
    },
    getStatistics(){
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where2)

      ButlerHttp.post(that.url,{
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);
    },
    openFlow(task_id){
      const that = this;
      if(!task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:task_id})
    },

  },
}
</script>

<style lang="scss" scoped>
.house-urge-lock-history-dialog{
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/HouseUrgeLockHistoryDialog.vue